


































































import {
	computed,
	defineComponent,
	onMounted,
	PropType,
	ref,
} from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SearchBox from '@front-app/components/search/SearchBox.vue';
import SearchPlaceholder from '@front-app/components/search/SearchPlaceholder.vue';
import SearchResult from '@front-app/components/search/SearchResult.vue';
import SelectedAdministratorButton from '@front-app/views/csr/community/SelectedAdministratorButton.vue';
import {
	AllMemberListingReportRequest,
	fetchAllMemberListingReport,
	UserReportResult,
} from '@front-app/services/CommunityApi/CommunityReportsApi';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { CommunityWithGroups, UpdateCommunityOrganizationRequest } from '@front-app/services/CommunityApi/CommunityModel';
import { Size, Spacing } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useCommunitiesStore } from '@front-app/store/piniaModules/communities';
import { UserAccountStatus } from '@front-app/services/UserApi/UserModel';
import { UserAvatarStore } from '@front-app/store/singletons/User';
import { useUsername } from '@front-app/hooks/useTranslate';

export default defineComponent({
	components: {
		CtaButton,
		ErrorCard,
		SearchBox,
		SearchPlaceholder,
		SearchResult,
		SelectedAdministratorButton,
	},
	props: {
		community: {
			type: Object as PropType<CommunityWithGroups>,
			required: false,
			default: null,
		},
	},
	setup(props, ctx) {
		const communitiesStore = useCommunitiesStore();
		const getUsername = useUsername(ctx);
		const userSearchEmail = ref('');
		const userSearchResults = ref([] as UserReportResult[]);
		const searchUsersStatus = useAsyncStatus();
		const selectedAdministrators = ref([] as UserReportResult[]);
		onMounted(() => {
			selectedAdministrators.value = props.community.administrators.map((administrator) => ({
				id: administrator.id,
				salutation: administrator.salutation,
				firstName: administrator.firstName,
				middleName: administrator.middleName,
				lastName: administrator.lastName,
				email: '',
				organizationName: '',
				accountStatus: UserAccountStatus.ACTIVATED,
				roles: [],
				specialties: [],
				interests: [],
			}));
		});

		const searchUsers = async () => {
			const payload: AllMemberListingReportRequest = {
				email: userSearchEmail.value,
				hasAvatar: null,
				roles: [],
				hasAnyRole: false,
				hasNoRoles: false,
				hasOrganization: null,
				specialtyIds: [],
				hasAnySpecialty: false,
				hasNoSpecialties: false,
				interestIds: [],
				hasAnyInterest: false,
				hasNoInterests: false,
				accountStatuses: [],
				primaryLanguage: null,
			};
			userSearchResults.value = await searchUsersStatus.track(fetchAllMemberListingReport(payload));
			userSearchResults.value = userSearchResults.value.sort((a, b) => a.firstName.localeCompare(b.firstName));
		};
		const handleSearchItemClicked = (user: UserReportResult) => {
			userSearchEmail.value = '';
			const selectedAdministratorIds = selectedAdministrators.value.map((administrator) => administrator.id);
			// Pre-select as administrator for confirmation
			if (selectedAdministratorIds.includes(user.id)) {
				selectedAdministrators.value = selectedAdministrators.value.filter((administrator) => administrator.id !== user.id);
			} else {
				selectedAdministrators.value = [...selectedAdministrators.value, user];
			}
		};
		const handleUserSearchInput = async (email: string) => {
			userSearchEmail.value = email;
			if (email.length > 2) {
				searchUsers();
			}
		};

		const areAdministratorsUnsaved = computed(() => {
			const selectedAdministratorIds = selectedAdministrators.value.map((user) => user.id);
			const existingAdministratorIds = props.community.administrators.map((administrator) => administrator.id);
			// eslint-disable-next-line prefer-const
			for (let id of selectedAdministratorIds) {
				if (!existingAdministratorIds.includes(id)) {
					return true;
				}
			}
			// eslint-disable-next-line prefer-const
			for (let id of existingAdministratorIds) {
				if (!selectedAdministratorIds.includes(id)) {
					return true;
				}
			}
			return false;
		});
		const updateAdministratorsStatus = useAsyncStatus();
		const updateAdministrators = async () => {
			const payload: UpdateCommunityOrganizationRequest = {
				administratorUserIds: selectedAdministrators.value.map((administrator) => administrator.id),
			};
			await updateAdministratorsStatus.track(communitiesStore.saveAdministrators(props.community.id, payload));
		};

		return {
			userSearchEmail,
			userSearchResults,
			getUsername,
			handleSearchItemClicked,
			handleUserSearchInput,
			getAvatar: UserAvatarStore.get,
			fetchAvatar: UserAvatarStore.fetch,
			selectedAdministrators,
			updateAdministrators,
			isErrorUpdatingAdministrators: updateAdministratorsStatus.isError,
			isUpdatingAdministrators: updateAdministratorsStatus.isLoading,
			isSuccessUpdatingAdministrators: updateAdministratorsStatus.isSuccess,
			areAdministratorsUnsaved,
			// Util
			ButtonPalettes,
			Size,
			Spacing,
		};
	},
});
